<template>
    <div>
        
              <h3>Similar Homes You May Like</h3>
              <v-row dense>
                <v-col cols=12
                 v-for="listing in suggested" :key="listing.ListingId">
                  <v-card :to="{ path: 'property', query: { mlsid: listing.ListingId }}" >
                    <div class="d-flex flex-no-wrap justify-space-between">
                      <div>
                        <v-avatar
                        class="float-left mr-3"
                        size="200"
                        tile
                      >
                        <v-img :src="listing.Media[0].MediaURL"></v-img>
                      </v-avatar>
                        <v-card-title
                          class=""
                          
                          
                        >
                        <p class="text-h4"> &nbsp;$ {{ formatPrice(listing.ListPrice) }}
                          </p>                                                    
                          </v-card-title>
                        
                        <v-card-body class="">
                          <p class="text-h6">
                          {{listing.StreetNumber}} {{ listing.StreetName }}, {{listing.City}}
                          <br>
                          Beds - {{listing.BedroomsTotal}}
                          <br>
                          Baths - {{ listing.BathroomsTotalInteger }}  
                        </p>
                        </v-card-body>
                      </div>
                      
                    </div>
                    
                  </v-card>

                </v-col>
              </v-row>

            </div>
          
</template>

<script>
// import Axios from 'axios'
    // import Axios from 'axios';
    export default {
        name: "Listings",
         props:{
            suggested: Array,
        },
        data() {
            return {
                
                
                // gps: this.$props.suggested.Longitude+","+this.$props.suggested.Latitude,
            }
        },
       
        methods:{
            formatPrice(value) {
                let val = (value/1).toFixed(0).replace(',', ',')
                return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            },

        },
    }
</script>

<style scoped>
a :hover{
  text-decoration: none;
}
</style>